module.exports = __webpack_public_path__ + "static/media/10.a6bc9194.jpg";